import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/assets/css/custom.css";
import "../src/assets/css/responsive.css";
import "../src/assets/css/icon.css";
import "../src/assets/css/theme.css";
import "../src/assets/css/policy.css";
import "../src/assets/css/nms.css";
import "../src/assets/css/overview-grid.css";
import Login from "./app/component/login/Login.js";
import UserProfile from "./app/component/login/userProfile.js";
import ForgotPassword from "./app/component/login/forgotPassword.js";
// import Dashboard from "./app/component/dashboard/dashboard.js";
import Overview from "./app/component/dashboard/overview/OverviewDashboard.js";
import DeviceListing from "./app/component/dashboard/deviceListing";
import ResetPassword from "./app/component/login/resetPassword";
import DeviceDetail from "./app/component/dashboard/deviceDetail";
import SnmpDevice from "./app/component/dashboard/snmpDevice";
import Layout from "./app/component/layout/Layout";
import Sidebar from "./app/component/common/Sidebar";
import Topology from "./app/component/dashboard/Topology.js";
import Alarms from "./app/component/dashboard/Alarms.js";
import SystemInfo from "./app/component/dashboard/systemInfo.js";
import OTAManagement from "./app/component/dashboard/OTAManagement.js";
import Audits from "./app/component/dashboard/Audits.js";
import DeviceDashboard from "./app/component/dashboard/DeviceDashboard.js";
import EdgeManagement from "./app/component/dashboard/EdgeManagement.js";
import DeviceDiscovery from "./app/component/dashboard/DeviceDiscovery.js";
import UserManagement from "./app/component/dashboard/UserManagement.js";
import SnmpTemplate from "./app/component/dashboard/snmpTemplate.js";
import TenantManagement from "./app/component/dashboard/TenantManagement.js";
import PrivateRoute from "./app/component/common/PrivateRoute";
import NotFound from "./app/component/common/NotFound.js";
import MQTT from "./app/component/dashboard/MQTT.js";
import TR069 from "./app/component/dashboard/TR069.js";
import Reports from "./app/component/dashboard/reports/Reports.js";
import DeviceSettings from "./app/component/dashboard/deviceSettings.js";
import DeviceLink from "./app/component/dashboard/deviceLink.js";
import LinkDetails from "./app/component/dashboard/LinkDetails.js";
import ReportList from "./app/component/dashboard/reports/reportList.js";
import Client from "./app/component/dashboard/Client.js";
import Troubleshoot from "./app/component/dashboard/Troubleshoot.js";
import WireDashboard from "./app/component/dashboard/wired/wireDashboard.js";
import WirelessDashboard from "./app/component/dashboard/wireless/wirelessDashboard.js";
import ClientExpandation from "./app/component/dashboard/wireless/ClientExpandation.js";
import TrafficBandwithExpandation from "./app/component/dashboard/wireless/trafficBandwidthExpandation.js";
import ConnectedClientExpandation from "./app/component/dashboard/wireless/ConnectedClientExpandation.js";
import ChannelUtilizationExpandation from "./app/component/dashboard/wireless/ChannelUtilizationExpandation.js";
import ClientDataExpandation from "./app/component/dashboard/wireless/ClientDataExpandation.js";
import WirelessDataExpandation from "./app/component/dashboard/wireless/WirelessDataExpandation.js";
import WifiConfig from "./app/component/dashboard/wireless/wifiConfig.js";
import WifiSetting from "./app/component/dashboard/wireless/wifiSetting.js";
import HttpsDetails from "./app/component/dashboard/HttpsDetail.js";
import WiredTrafficExpansion from "./app/component/dashboard/wired/WiredTrafficExpansion.js";
import WiredUsageExpansion from "./app/component/dashboard/wired/WiredUsageExpansion.js";
import WiredPowerExpansion from "./app/component/dashboard/wired/WiredpowerExpansion.js";
import WiredConfiguration from "./app/component/dashboard/wired/wiredConfiguration.js";
import HTTPS from "./app/component/dashboard/HTTPS.js";
import Notification from "./app/component/dashboard/Notification.js";
import ConfigureNetwork from "./app/component/dashboard/wired/configureNetwork.js";
import HttpDashboard from "./app/component/dashboard/httpDashboard.js";
import { ThemeProvider } from "./app/component/ThemeContext.js";
import ReportsPDF from "./app/component/dashboard/reports/reportPdf.js";
import Tr069Dashboard from "./app/component/dashboard/tr069Dashboard.js";
import Tr069Config from "./app/component/dashboard/Tr069Config.js";
import { useLocalization } from "./app/component/localization/LocalizationContext.js";
import LicenseProfile from "./app/component/License/LicenseProfile.js";
import HomePage from "./app/component/PrivacyPolicy/HomePage.js";
import CustomerOverview from "./app/component/PrivacyPolicy/Customer.js";
import PrivacyHTML from "../src/app/component/login/privacyHTML.js";
import CustomerHTML from "../src/app/component/login/customerHTML.js";
import TermsUse from "./app/component/login/termOfUseHTML.js";
import PrivacyPolicyAgreement from "./app/component/login/PrivacyPolicyAgreement.js";
import UserLicense from "./app/component/login/userLIcenseHTML.js";
import UserDetails from "./app/component/login/UserDetails.js";
import UserDevice from "./app/component/login/deviceHTML.js";
import DeviceSimulator from "./app/component/login/deviceSimulatotHTML.js";
// import { LanguageProvider } from "./app/component/LanguageContext.js";
import Anomalies from "./app/component/dashboard/Anomalies.js";
import ClientRoaming from "./app/component/dashboard/wireless/ClientRoaming.js";
import Floormap from "./app/component/dashboard/FloorMap/Floormap.js";
import { SidebarProvider } from "./app/component/common/sidebarContext.js";
import Chat from "./app/component/common/chat.js";
function App() {
  const { localizationStrings } = useLocalization();
  const location = useLocation();
  const isPublicPage =
    location.pathname === "/" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/kb" ||
    location.pathname.startsWith("/public");

  // location.pathname === "/not-found";

  return (
    // <LanguageProvider>
    <SidebarProvider>

      <ThemeProvider>
        <div className="app-container">
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/kb" element={<PrivacyHTML />} />
              <Route path="/public/customers" element={<CustomerHTML />} />
              <Route path="/public/users" element={<UserDetails />} />
              <Route path="/public/device" element={<UserDevice />} />
              <Route
                path="/public/device-simulator"
                element={<DeviceSimulator />}
              />

              <Route
                path="/public/privacyPolicy"
                element={<PrivacyPolicyAgreement />}
              />
              <Route path="/public/terms-of-use" element={<TermsUse />} />
              <Route path="/public/userLicense" element={<UserLicense />} />
              <Route path="/user-profile" element={<UserProfile />} />
              <Route path="/license-profile" element={<LicenseProfile />} />
              <Route path="/ReportsPDF" element={<ReportsPDF />} />
              {/* <Route path="/not-found" element={<NotFound />} /> */}
              {/* <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout heading="Dashboard">
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          /> */}
              <Route
                path="/overview"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.overview}>
                      <Overview />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/floormap"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.floorMap}>
                      <Floormap />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/device-listing"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceManagement}>
                      <DeviceListing />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/device-detail"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceDetail}>
                      <DeviceDetail />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/device-snmp"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceInformation}>
                      <SnmpDevice />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/topology"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceTopology}>
                      <Topology />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/OTAManagement"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.otaManagement}>
                      <OTAManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/alarms"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.alerts}>
                      <Alarms />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/system-info"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.systemInformation}>
                      <SystemInfo />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/user-management"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.userManagement}>
                      <UserManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/audits"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.audits}>
                      <Audits />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/device-dashboard"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceDashboard}>
                      <DeviceDashboard />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/http-dashboard"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.httpDashboard}>
                      <HttpDashboard />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/device-settings"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceSettings}>
                      <DeviceSettings />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/device-link"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.linkModule}>
                      <DeviceLink />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/link-details"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.linkModule}>
                      <LinkDetails />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edge-management"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.edgeManagement}>
                      <EdgeManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/device-discovery"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceDiscovery}>
                      <DeviceDiscovery />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/tenant-management"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.tenantManagement}>
                      <TenantManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/modal-management/create-template"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.snmpTemplate}>
                      <SnmpTemplate />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/modal-management/mqtt"
                element={
                  <PrivateRoute>
                    <Layout heading="MQTT">
                      <MQTT />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/modal-management/tr069"
                element={
                  <PrivateRoute>
                    <Layout heading="TR-069">
                      {/* Your TR-069 component */}
                      <TR069 />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/modal-management/https"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.httpsManagement}>
                      <HTTPS />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/allReports"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.reports}>
                      <Reports />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/report-generate"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.reports}>
                      <ReportList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wired"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wiredDashboard}>
                      <WireDashboard />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wireless"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wirelessDashboard}>
                      <WirelessDashboard />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/client"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.client}>
                      <Client />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/troubleshoot"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.troubleshoot}>
                      <Troubleshoot />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/client-expandation"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings.wirelessDashboard}>
                      <ClientExpandation />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/trafficBandwidth-expandation"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings.wirelessDashboard}>
                      <TrafficBandwithExpandation />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/ConnectedClients-expandation"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings.wirelessDashboard}>
                      <ConnectedClientExpandation />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wirelessDataGraph-expandation"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings.wirelessDashboard}>
                      <WirelessDataExpandation />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/ClientData-expandation"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings.wirelessDashboard}>
                      <ClientDataExpandation />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/ChannelUtilization-expandation"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings.wirelessDashboard}>
                      <ChannelUtilizationExpandation />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wifi-settings"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wifiSettings}>
                      <WifiSetting />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wifi-config"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wifiConfiguration}>
                      <WifiConfig />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/https-info"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.deviceInformation}>
                      <HttpsDetails />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wiredtraffic-expansion"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wiredDashboard}>
                      <WiredTrafficExpansion />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wiredusage-expansion"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wiredUsage}>
                      <WiredUsageExpansion />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wiredpower-expansion"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wiredPower}>
                      <WiredPowerExpansion />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/wired-config"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wiredConfiguration}>
                      <WiredConfiguration />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/notification"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.notifications}>
                      <Notification />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/configureNetwork"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.configureNetwork}>
                      <ConfigureNetwork />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/chat"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.chat}>
                      <p className="nms-empty">Use the assistant from the button on the right.</p>
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/network-management/wired-config"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wiredConfiguration}>
                      <WiredConfiguration />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/network-management/wifi-config"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.wifiConfiguration}>
                      <WifiConfig />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/tr069-dashboard"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.tr069Dashboard}>
                      <Tr069Dashboard />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/tr069-config"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.tr069Configuration}>
                      <Tr069Config />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/anomalies"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.anomalies}>
                      <Anomalies />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/privacy-policy"
                element={
                  <PrivateRoute>
                    <Layout heading={localizationStrings?.PrivacyPolicy}>
                      <HomePage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/customer"
                element={
                  <PrivateRoute>
                    <Layout heading="Customer">
                      <CustomerOverview />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/client-roaming"
                element={
                  <PrivateRoute>
                    <Layout heading="Client Roaming">
                      <ClientRoaming />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
            {!isPublicPage && <Chat />}
          </div>
        </div>
      </ThemeProvider>
    </SidebarProvider>
    // </LanguageProvider>
  );
}

export default App;
